import React from 'react';
import './portfolio.css';
import Item from './item';

class Portfolio extends React.Component {
  componentDidMount() {
    const links = document.querySelectorAll('nav a');
    links[0].parentElement.classList += 'active';
  }
  render() {
    return (
      <main>
        <h2>Portfolio</h2>
        <Item />
      </main>
    );
  }
}

export default Portfolio;



// WEBPACK FOOTER //
// ./src/components/Portfolio/Portfolio.js